import React, { useEffect, useState } from 'react'
import { Badge, Card, Col, Container, Dropdown, Form, Modal, Row, Table } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import SubMenuDatabase from '../../components/menus/SubMenuDatabase'
import CandidateProfile from '../admin/CandidateProfile'
import Swal from 'sweetalert2'
import { editMultiSchoolStock, getStocksByMultiSchool } from '../../actions/stocksActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { getTitles } from '../../actions/candidatesActions'
import { getReducedSchoolsByMultiSchool } from '../../actions/schoolsActions'
import Select from "react-select"

export default function BlockedDatabase() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {schools} = useSelector(state=>state.schools)
    const {result, stocksWithCandidates, loading} = useSelector(state => state.stocks)
    const {titles} = useSelector(state=>state.candidates)

    const [selectedCandidate, setSelectedCandidate] = useState(null)
    const [selectedStockToEdit, setSelectedStockToEdit] = useState(null)
    const [stockFormState, setStockFormState] = useState({
        movement: "edit"
    })
    
    const handleEditStock = (stock, stockType) => {
        const newFormState = {
            ...stockFormState,
            stock: stock,
            stockType: stockType,
            previousSchools: stock.schools
        }

        if(stockType === 'favourite'){
            newFormState.scope = "same"
        }

        if(stockType === 'blocked'){
            newFormState.schools = stock?.schools?.map(school => {return {value: school._id, label: school.name}})
        }

        setSelectedStockToEdit(stock)
        setStockFormState(newFormState)
    }

    const handleCloseStockModal = () => {
        setSelectedStockToEdit(null)
        setStockFormState({
            movement: "edit"
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const formStateCopy = {...stockFormState, multiSchool: client?.id}

        if(formStateCopy.stockType === 'favourite'){
            if (formStateCopy.scope === 'same') {
                formStateCopy.schools = formStateCopy.previousSchools.map(school => school._id)
            } else {
                formStateCopy.schools = schools.map(school => school.id)
            }
        }

        if(formStateCopy.stockType === 'blocked'){
            formStateCopy.schools = formStateCopy.schools.map(school => school.value)
        }

        dispatch(editMultiSchoolStock(formStateCopy))
    }

    useEffect(() => {
        if(client){
            dispatch(getTitles())
            getStocksByMultiSchool(client._id)
            dispatch(getReducedSchoolsByMultiSchool(client?.id))
        }
    },[dispatch, client])

    useEffect(() => {
        if(result){
            dispatch({type: 'STOCK_RESET_RESULT'})
            switch (result) {
                case 'editSuccess':
                    dispatch(getStocksByMultiSchool(client.id))
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('database.stockEditedSuccess'),
                    })
                    break;
                default:
                    break;
            }
            setSelectedStockToEdit(null)
            setStockFormState({
                movement: "edit"
            })
        }
    // eslint-disable-next-line
    }, [result, client, dispatch])

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/menus/database.svg" alt="Base de datos" />
                        <h1 className='ms-2 m-0'>{t('menus.database')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <SubMenuDatabase section="blocked"/>
                                <Row className='my-3'>
                                    <Col xs={10}>
                                        <h3 className='ms-2 m-0'>{t('database.submenu.blocked')} ({stocksWithCandidates.filter(stock => stock.typeStock.includes('blocked')).length})</h3>
                                    </Col>
                                </Row>
                                <Row className='my-3'>
                                    <Col className='my-3'>
                                        {
                                            loading
                                            ?
                                                <div className='text-center'>
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </div>
                                            :
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>{t('school.selection.name')}</th>
                                                            <th>{t('profile.availability')}</th>
                                                            <th>{t('menus.schools')}</th>
                                                            <th>{t('users.town')}</th>
                                                            <th>{t('profile.candidate.officialTitles')}</th>
                                                            <th className='bg-grey text-center' style={{width: '150px'}}>{t('global.actions')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            stocksWithCandidates?.filter(stock => stock?.typeStock?.includes('blocked'))?.map((stock, index) => (
                                                                <tr key={index}>
                                                                     <td className='d-flex align-items-center'>
                                                                        <div className='avatar-mini list cursor me-2' onClick={() => setSelectedCandidate(stock.user._id)}>
                                                                            <div className='img-profile' style={{backgroundImage: `url(${stock.user?.image ? stock.user.image : "/images/avatar-empty.svg"})`}}/>
                                                                        </div>
                                                                        { stock.candidate.firstname } { stock.candidate.lastname }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        { stock.candidate.searching === true ? t('global.yes') : t('global.no') }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        {
                                                                            stock?.schools?.map((school, schoolIndex) => (
                                                                                <Badge key={schoolIndex} className='bg-grey text-muted p-2 mx-1'>{school.name}</Badge>
                                                                            ))
                                                                        }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        { `${stock.candidate.town ? `${towns.find(t => t.value === stock.candidate.town)?.label}${stock.candidate.province ? ` (${provinces.find(p => p.value === stock.candidate.province)?.label})` : ''}` : ''}` }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        { stock?.candidate?.academic?.map((academic, academicIndex) => (
                                                                            <Badge key={academicIndex} className='bg-grey text-muted p-2 mx-1'>{titles?.find(t => t.id == academic.title) ? t('titles.' + titles?.find(t => t.id == academic.title).title) : academic.title}</Badge>
                                                                        )) }
                                                                    </td>
                                                                    <td className='bg-grey text-center'>
                                                                        <Dropdown drop='start'>
                                                                            <Dropdown.Toggle as="img" src="/images/options.svg" className='cursor'/>
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item as="div" className='cursor' onClick={() => handleEditStock(stock, 'blocked')}>
                                                                                    {t("database.editBlocked")}
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item as="div" className='cursor' onClick={() => handleEditStock(stock, 'favourite')}>
                                                                                    {t("database.addFavourite")}
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                        }
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={selectedCandidate ? true : false} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
						<div>
							<i className='fa fa-times cursor' onClick={() => setSelectedCandidate(null)}></i>
						</div>
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					<CandidateProfile candidateToShow={{iduser: selectedCandidate}}/>
                </Modal.Body>
            </Modal>
            <Modal size='lg' show={selectedStockToEdit ? true : false} aria-labelledby="example-custom-modal-styling-title" onHide={handleCloseStockModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("database." + (stockFormState.stockType === "blocked" ? "editBlocked" : "addFavourite"))}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        {
                            stockFormState.stockType === "blocked"
                            ?
                                <Form.Group>
                                    <Form.Label>{t('database.blockedSchools')}</Form.Label>
                                    <Select
                                        isMulti
                                        name='schools'
                                        className="select mb-2"
                                        options={schools?.map(school => {return {value: school.id, label: school.name}})}
                                        value={stockFormState.schools}
                                        onChange={(selectedValues) => {
                                            setStockFormState({
                                                ...stockFormState,
                                                schools: selectedValues
                                            })
                                        }}
                                    />
                                    <span className='text-muted'>{t('database.schoolsBlockedDescription')}</span>
                                </Form.Group>
                            :
                                stockFormState.stockType === "favourite"
                                ? 
                                    <Form.Group>
                                        <Form.Label>{t('database.favouriteScope')}</Form.Label>
                                        <Form.Select
                                            className='mb-2'
                                            value={stockFormState.scope}
                                            onChange={(e) => {
                                                setStockFormState({
                                                    ...stockFormState,
                                                    scope: e.target.value
                                                })
                                            }}
                                        >
                                            <option value="same">{t('database.sameSchools')}</option>
                                            <option value="all">{t('database.allSchools')}</option>
                                        </Form.Select>
                                    </Form.Group>
                                :
                                    <></>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='button' className='btn btn-secondary' onClick={handleCloseStockModal}>
                            {t('global.cancel')}
                        </button>
                        <button className='btn btn-primary' type='submit'>
                            {t('global.save')}
                        </button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}